import { HotelRoomingListGuestAdapter } from './hotel-rooming-list-guest.ts'

import type {
  HotelRoomingListApi,
  HotelRoomingListGuestApi,
} from '@revolugo/booking-api-client'
import type {
  HotelRoom,
  HotelRoomingList,
  HotelRoomingListGuest,
} from '@revolugo/graphql/private'

export interface HotelRoomingListAdapterProps
  extends Pick<HotelRoomingList, 'id'> {
  hotelRoom: Pick<HotelRoom, 'name' | 'occupancy'>
  limitDate: string
  hotelRoomingListGuests: HotelRoomingListGuest[]
}

export class HotelRoomingListAdapter {
  public hotelRoomingListApi: HotelRoomingListApi
  public hotelRoomingListGuestsApi: HotelRoomingListGuestApi[]

  constructor(hotelRoomingListApi: HotelRoomingListApi) {
    this.hotelRoomingListApi = hotelRoomingListApi
    this.hotelRoomingListGuestsApi = hotelRoomingListApi.hotelRoomingListGuests!
  }

  toHotelRoomingList(): HotelRoomingListAdapterProps {
    return {
      ...this.hotelRoomingListApi,
      hotelRoom: this.mapHotelRoomApiToHotelRoom()! as HotelRoom,
      hotelRoomingListGuests: this.hotelRoomingListGuestsApi!.map(guest => {
        const hotelRoomingListGuest = new HotelRoomingListGuestAdapter(
          guest,
          this.hotelRoomingListApi.id,
        )
        return hotelRoomingListGuest.toHotelRoomingListGuest()
      }),
      limitDate: this.hotelRoomingListApi.limitDate!,
    }
  }

  private mapHotelRoomApiToHotelRoom(): Pick<HotelRoom, 'name' | 'occupancy'> {
    return {
      name: this.hotelRoomingListApi.hotelRoom!.description,
      occupancy: this.hotelRoomingListApi.hotelRoom!.occupancy,
    }
  }

  private mapHotelRoomingListApiToRoomingListGuests(): Omit<
    HotelRoomingListGuest,
    '__typename'
  >[] {
    return this.hotelRoomingListApi.hotelRoomingListGuests!.map(guest => ({
      __typename: 'HotelRoomingListGuest',
      ...guest,
      hotelRoomingListId: this.hotelRoomingListApi.id,
    }))
  }
}
